import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbComponent } from '../../../shared/components/breadcrumb/breadcrumb.component';
import { CanonicalService } from '../../../shared/seo/canonical.service';
import { SeoService } from '../../../shared/seo/seo.service';
import { ClevertapService } from '../../../shared/services/clevertap/clevertap.service';
import { CommonService } from '../../../shared/services/common.service';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';

@Component({
  selector: 'app-reward-terms-condition',
  templateUrl: './reward-terms-condition.component.html',
  styleUrls: ['./reward-terms-condition.component.scss'],
})
export class RewardTermsConditionComponent implements OnInit {
   sub: Subscription = new Subscription();
  @ViewChild(BreadcrumbComponent) breadCrumb: BreadcrumbComponent;
  environment1 = environment.s3bucket.url;
  breadcrumbData: any = [];
  isMobile: boolean = false;
  maximumSize: any = 6;
  show: any;
  metatitle: any = 'Tata Motors Terms & Conditions | Legal Information';
  metadesc: any =
    'Enquire, book and buy online Tata Ace, Intra, Yodha Pickup, Winger, Magic, Signa, Prima, Ultra, and entire Truck, Tipper, Bus range with Tata Motors authorized dealers.';
  page: string;
productID:any;
  productDetailList: any;
  breadcrumbdata: any = [];
  showBreadCrumb: boolean = false;
  breadcrumbList: {
    label: any;
    url: string;
    pageName: string;
  };
  isBooking : boolean = false;
  scheme: any;
  constructor(
    private canonicalservice: CanonicalService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cleverService: ClevertapService,
    private seoservice: SeoService,private apiService: ApiService,
    private commonService:CommonService,private localStorage: secureStorage,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const storedData = this.localStorage.getItem('rewardTermsCondition');
if (storedData) {
  this.scheme  = JSON.parse(storedData);
}
      $('.header').addClass('p-scroll');
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.isMobile = true;
        this.maximumSize = 4;
      } else {
        this.isMobile = false;
        this.maximumSize = 6;
      }
      try {
        this.cleverService.onPageView('Terms and Conditions');
      } catch {}
    }
    this.activatedRoute.queryParams.subscribe(params => {
      // if (params?.get('page')) {
      //   this.page = params.get('page');
      //   this.tabChange(this.page)
      // }
      // else {
      //   this.tabChange('Terms & Condition')
      //   this.page = 'Terms & Condition';
      // }
      this.productID = params['id'];
      this.isBooking = params['isBooking'];
    });
    this.activatedRoute.paramMap.subscribe(params => {
      if (params?.get('page')) {
        this.page = params.get('page');
        this.tabChange(this.page)
      }
      else {
        this.tabChange('Reward Terms & Condition')
        this.page = 'Reward Terms & Condition';
      }
    });
    if (this.productID) {
    this.getVehicleDetail('')
    }
  }
  showHide(item) {
    this.show = item;
  }
  seo() {
    this.seoservice.updateTitle(this.metatitle);
    this.seoservice.updateMetaTag('description', null, this.metadesc);
    this.seoservice.updateMetaTag(null, 'og:locale', 'en_US');
    this.seoservice.updateMetaTag(null, 'og:type', 'Website');
    this.seoservice.updateMetaTag(null, 'og:title', this.metatitle);
    this.seoservice.updateMetaTag(null, 'og:description', this.metadesc);
    this.seoservice.updateMetaTag(
      null,
      'og:url',
      environment.baseUrl + this.router.url
    );
    this.seoservice.updateMetaTag(null, 'og:site_name', 'Tata OSP');
  }

  tabChange(item: any) {
    localStorage.removeItem('localBreadCrumb');
    this.page = item == 'Terms & Condition' ? 'Terms & Condition' : item;
    if (this.page == 'Terms & Condition') {
      this.commonService.showBreadCrumbb('Terms & Condition');
    } else {
      this.commonService.showBreadCrumbb(this.page);
    }
     this.breadCrumb?.getBreadCrumb()
  }
  getVehicleDetail(id: any) {
   let data = {
      product_id : this.productID
    }
    this.sub.add(
      this.apiService.getVehicleDetails(data).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.productDetailList = res?.data;

            this.breadcrumb();
          }
        },
        error: () => {

        },
        complete: () => {

        },
      })
    );
  }
  breadcrumb() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('sideFilter');
      localStorage.removeItem("ExploreMappedData")
      localStorage.removeItem("ExploreMappedData1")
      localStorage.removeItem("explore")
      localStorage.removeItem("EModeldData")
      localStorage.removeItem('ExploreMappedDatatype')
      localStorage.removeItem('ExploreMappedDatamodal')
      localStorage.removeItem('localBreadCrumb');
    }
    this.breadcrumbList = {
      label:
        this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
        'icv-trucks'
          ? 'Trucks'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'buses'
          ? 'Buses & Vans'
          : this.productDetailList.sub_lob,
      url:
        `/product-list/` +
        (this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
        'icv-trucks'
          ? 'trucks'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'buses'
          ? 'buses-vans'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase()),
      pageName: 'product-details',
    };

    this.breadcrumbdata.push(this.breadcrumbList);

    this.breadcrumbList = {
      label: this.productDetailList.lob,
      url:
        `/category-list/` +
        (this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
        'icv-trucks'
          ? 'trucks'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'buses'
          ? 'buses-vans'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase()) +
        `/` +
        this.productDetailList.lob?.replace(/\s/g, '-')?.toLowerCase(),
      pageName: 'product-details',
    };
    this.breadcrumbdata.push(this.breadcrumbList);

    this.breadcrumbList = {
      label: this.productDetailList.ppl,
      url:
        `/product-list/` +
        (this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
        'icv-trucks'
          ? 'trucks'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'buses'
          ? 'buses-vans'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase()) +
        `/` +
        this.productDetailList.lob?.replace(/\s/g, '-')?.toLowerCase() +
        `/` +
        this.productDetailList.ppl
          ?.replace(/\s/g, '-')
          .replace('---', '-')
          .replace('/', '-')
          ?.toLowerCase(),
      pageName: 'product-list',
    };
    this.breadcrumbdata.push(this.breadcrumbList);

    this.breadcrumbList = {
      label: this.productDetailList.model,
      url: '',
      pageName: 'product-details',
    };
    this.breadcrumbdata.push(this.breadcrumbList);


if (this.isBooking) {


    let sublob =
        this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
        'icv-trucks'
          ? 'trucks'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'buses'
          ? 'buses-vans'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase();
          let model = this.productDetailList.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
  let url =
        '/lead-booking/' +
          sublob +
          '/' +
          this.productDetailList.lob_seo +
          '/' +
          this.productDetailList.ppl_seo +
          '/' +
          model +
          '/' +
          this.productDetailList.id

      this.breadcrumbList = {
        label: 'BOOK NOW',
        url: url,
        pageName: 'book-now',
      };
      this.breadcrumbdata.push(this.breadcrumbList);


    }
      this.breadcrumbList = {
        label: 'reward terms & condition',
        url: '',
        pageName: 'reward-terms-condition',
      };
      this.breadcrumbdata.push(this.breadcrumbList);


    if (isPlatformBrowser(this.platformId)) {
      this.localStorage.setItem(
        'localBreadCrumb',
        JSON.stringify(this.breadcrumbdata)
      );
    }
    this.showBreadCrumb = true;
  }
  redirect() {
    var url =  this.localStorage.getItem('currentRoute');
      return url;
  }
}
